import { AccountActions } from '../../../components/account-actions'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import {
    AccountTopWrapper,
    Heading,
    Container,
    MainContent,
    CustomAvatar,
    MainContentWrapper
} from '../../../styles/account'



const TeacherAccount = () => {
    return (
        <DashboardWrapper>
            <AccountTopWrapper teacher >
                <Container>
                    <MainContent>
                        <div className="top">
                            <h1 className="account-name">Bello Ade</h1>
                            <div className="image-container">
                                <CustomAvatar alt="Name" src="/assets/images/account-avatar.webp" />
                            </div>
                        </div>
                        <div className="bottom">
                            <div className="school-info">
                                <p className="main-school">Klasconnect Portal</p>
                                <p className="sub-school">Temple College, Lagos State.</p>
                            </div>
                            <div className="lecturer-info">
                                <p className="position">lecturer</p>
                                <p className="reg-number">REGISTRATION ID: 010</p>
                            </div>
                            <div className="contact-info">
                                <p className="personal-number">Personal Number: 09092232851</p>
                                <p className="parent-number">Parent's Number: 09092232851</p>
                            </div>
                        </div>
                    </MainContent>
                </Container>
            </AccountTopWrapper>
            <MainContentWrapper>
                <MainContent>
                    <Container>
                        <Heading>Welcome, Bello</Heading>
                        <AccountActions />
                    </Container>
                </MainContent>
            </MainContentWrapper>

        </DashboardWrapper>
    )
}

export default TeacherAccount
